module.exports = __webpack_public_path__ + "img/product7.a8e094bc.png";